/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Venue_UnknownInputs */

const cs_calendar_venue_unknown = /** @type {(inputs: Calendar_Venue_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neznámá pobočka`)
};

const en_calendar_venue_unknown = /** @type {(inputs: Calendar_Venue_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unknown branch`)
};

/**
* | output |
* | --- |
* | "Unknown branch" |
*
* @param {Calendar_Venue_UnknownInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_venue_unknown = /** @type {((inputs?: Calendar_Venue_UnknownInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Venue_UnknownInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_venue_unknown(inputs)
	return cs_calendar_venue_unknown(inputs)
});